import React from 'react';
import { Tooltip } from '../../core/tooltip/tooltip.component';
import styles from './buttons.module.scss';
import classNames from 'classnames';

/**
 * Simple wrapper that adds aria-label and tooltip to anchor tags for accessibility.
 * @typedef {import('react').AnchorHTMLAttributes<HTMLAnchorElement>} IconAnchorProps
 * @param {IconAnchorProps & {
 *  label: string,
 *  showTooltip?: boolean,
 * }} params
 */
export function IconAnchor({ label, showTooltip = true, ...props }) {
  const a = (
    <a {...props} aria-label={label} className={classNames(styles.iconAnchor, props.className)} />
  );

  if (showTooltip && label) {
    return <Tooltip title={label}>{a}</Tooltip>;
  }

  return a;
}
